export const NAME = 'nav';

// Actiontypes
export const SHOW_SUB_NAV = 'SHOW_SUB_NAV';
export const HIDE_SUB_NAV = 'HIDE_SUB_NAV';

export const SUB_NAV_CATEGORIES = 'SUB_NAV_CATEGORIES';



// WEBPACK FOOTER //
// ./src/services/nav/constants.js